import { AutorunComponent } from '@myshared/autorun.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'src/app/subscription/subscription.model';


@Component({
    selector: 'app-base-price-card',
    templateUrl: './base-price-card.component.html',
    standalone: false
})
export class BasePriceCardComponent extends AutorunComponent {
  @Input() public prefixOfPrice: string = '+';
  @Input() public price: number = 0;
  @Input() public name: string;
  @Input() public product: string;
  @Input() public isSelected: boolean = false;
  @Input() public showSelectButton: boolean = false;
  @Input() public showHeader = false;
  @Input() public timeBilling: string = 'price_per_month';
  @Input() public buttonText: string;

  @Output() public readonly selected = new EventEmitter<string>();
  @Output() public readonly backEmitter = new EventEmitter<void>();

  constructor() { 
    super();
  }

  get formattedPricePrefix(): string {
    if (this.price === 0 && this.prefixOfPrice === '+') {
      return '';
    } else {
      return this.prefixOfPrice;
    }
  }

  back() { 
    this.backEmitter.emit();
  }

  select() {
    if (this.isSelected && !this.showSelectButton) {
      return;
    }
    this.selected.emit(this.product);
  }

  getCssClasses() {
    return {
      normal: !this.isSelected,
      highlight: this.isSelected
    };
  }
}
